import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import Plan from '@/components/plan/Plan'
import Productcenter from '@/components/productCenter/Productcenter'
import CModel from '@/components/productCenter/CModel'
import BModel from '@/components/productCenter/BModel'
import Parksoftware from '@/components/productCenter/parkSoftWare'
import Other from '@/components/productCenter/other'
import Productbest from '@/components/productbest/Productbest'
import Ck from '@/components/ck/Ck'
import Example from '@/components/example/Example'
import About from '@/components/About/About'
import Error from '@/components/error/Error'
Vue.use(Router)

export default new Router({
  //  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {scrollToTop: true}
      //  meta: (0, 0)
    },
    {
      path: '/Plan',
      name: 'Plan',
      component: Plan,
      meta: {scrollToTop: true}
      //  meta: (0, 0)
    },
    {
      path: '/Productcenter',
      name: 'Productcenter',
      component: Productcenter,
      meta: {scrollToTop: true},
      //  meta: (0, 0),
      children: [{
        path: '/',
        redirect: '/CModel',
        component: CModel
      }, {
        path: '/CModel',
        name: 'CModel',
        component: CModel
      }, {
        path: '/BModel',
        name: 'BModel',
        component: BModel
      }, {
        path: '/Parksoftware',
        name: 'Parksoftware',
        component: Parksoftware
      }, {
        path: '/Other',
        name: 'Other',
        component: Other
      }]
    },
    {
      path: '/Productbest',
      name: 'Productbest',
      component: Productbest,
      meta: {scrollToTop: true}
      //  meta: (0, 0),
    },
    {
      path: '/Ck',
      name: 'Ck',
      component: Ck,
      meta: {scrollToTop: true}
      //  meta: (0, 0),
    },
    {
      path: '/Example',
      name: 'Example',
      component: Example,
      meta: {scrollToTop: true}
      //  meta: (0, 0),
    },
    {
      path: '/About',
      name: 'About',
      component: About,
      meta: {scrollToTop: true}
      //  meta: (0, 0),
    },
    {
      path: '*',
      name: 'Error',
      component: Error
    }
  ],
  scrollBehavior: function (to, from, savedPosition) {
    return to.meta
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js